var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewWidthInside3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "169px",
    height: "214px",
    viewBox: "0 0 450 570",
    enableBackground: "new 0 0 450 570",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 84.9,
    y: 116.9,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 140,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 120.9,
    y1: 313.4,
    x2: 329.1,
    y2: 313.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "123.5,322.4 108,313.4 123.5,304.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "326.5,322.4 342,313.4 326.5,304.4  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M399.3,174.4l6.5-16h2.5l6.4,16h-2.3l-1.4-3.6h-8l-1.4,3.6H399.3z M403.6,169.1h6.8l-3.4-8.6L403.6,169.1 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M401.3,321v-16h7.1c1.4,0,2.5,0.4,3.3,1.1c0.8,0.8,1.2,1.7,1.2,3c0,1-0.3,1.8-0.8,2.4s-1.2,1.1-2,1.2 c0.8,0.1,1.6,0.6,2.2,1.4c0.6,0.8,0.9,1.6,0.9,2.6c0,1.3-0.4,2.4-1.2,3.1c-0.8,0.8-2,1.2-3.4,1.2H401.3z M403.3,311.9h4.8 c0.9,0,1.6-0.2,2-0.7s0.7-1.1,0.7-1.8c0-0.7-0.2-1.4-0.7-1.9c-0.5-0.5-1.2-0.7-2-0.7h-4.8V311.9z M403.3,319.2h4.9 c0.9,0,1.6-0.2,2.2-0.7s0.8-1.2,0.8-2c0-0.8-0.3-1.4-0.8-2s-1.2-0.8-2.2-0.8h-4.9V319.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M400.8,456.8c-0.4-1-0.6-2.2-0.6-3.4s0.2-2.3,0.6-3.4c0.4-1,1-1.9,1.7-2.6c0.7-0.7,1.6-1.3,2.6-1.7 s2.1-0.6,3.2-0.6c2.6,0,4.6,1.1,6.1,3.2l-1.7,0.9c-0.5-0.7-1.1-1.3-1.9-1.7s-1.6-0.6-2.5-0.6c-1.8,0-3.2,0.6-4.4,1.8 s-1.8,2.8-1.8,4.7c0,1.2,0.3,2.4,0.8,3.4s1.3,1.8,2.2,2.3s2,0.8,3.1,0.8c0.9,0,1.7-0.2,2.5-0.6s1.4-1,1.9-1.7l1.7,0.9 c-1.6,2.1-3.6,3.2-6.1,3.2c-1.1,0-2.2-0.2-3.2-0.6s-1.9-1-2.6-1.7C401.8,458.7,401.2,457.8,400.8,456.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 120.9,
    y1: 166.8,
    x2: 329.1,
    y2: 166.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "123.5,175.8 108,166.8 123.5,157.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "326.5,175.8 342,166.8 326.5,157.8  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 120.9,
    y1: 453.8,
    x2: 329.1,
    y2: 453.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "123.5,462.8 108,453.8 123.5,444.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "326.5,462.8 342,453.8 326.5,444.8  "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWidthInside3);
export default __webpack_public_path__ + "static/media/new_width_inside_3.fe4ec7bbc7fa529cb8a0ed4445e6329c.svg";
export { ForwardRef as ReactComponent };